import { useBranchEditor } from "features/editor/Feature";
import { Icon, Text, Stack, Paragraph, Button } from "prism-react";
import React from "react";

import { paths } from "utils/router";

import { ShareContainer } from "./ShareContainer";

export const ShareRepositoryProject: React.FC<{
  editorURL: URL;
}> = ({ editorURL }) => {
  const { isPrivate, workspace } = useBranchEditor();
  const repositoryIsWorkspaceScoped = Boolean(workspace);

  let content;

  if (isPrivate) {
    content = (
      <Stack css={{ alignItems: "flex-start" }} gap={4}>
        <Stack horizontal>
          <Icon size={4} type="lockClose" />
          <Text>Private repository</Text>
        </Stack>
        <Paragraph css={{ color: "$neutral-fg-base" }}>
          This branch can only be seen or edited by team members in your
          workspace.
        </Paragraph>
        <Button
          as="a"
          href={paths.dashboard.workspaceSettings(workspace!.id)}
          icon="user"
          iconSize={3}
          rel="noreferrer noopener"
          target="_blank"
          variant="secondary"
        >
          Edit workspace members
        </Button>{" "}
      </Stack>
    );
  } else {
    content = (
      <Stack css={{ alignItems: "flex-start" }} gap={4}>
        <Stack horizontal>
          <Icon size={4} type="community" />
          <Text>Public repository</Text>
        </Stack>

        {repositoryIsWorkspaceScoped ? (
          <>
            <Paragraph css={{ color: "$neutral-fg-base" }}>
              Everyone with the URL can see and fork the remote version of this
              branch. Team members in your workspace can see your local changes,
              and those with editor permissions can edit it.
            </Paragraph>
            <Button
              as="a"
              href={paths.dashboard.workspaceSettings(workspace!.id)}
              icon="user"
              iconSize={3}
              rel="noreferrer noopener"
              target="_blank"
              variant="secondary"
            >
              Edit workspace members
            </Button>{" "}
          </>
        ) : (
          <Paragraph css={{ color: "$neutral-fg-base" }}>
            Everyone can access this branch with the copied url.
          </Paragraph>
        )}
      </Stack>
    );
  }

  return <ShareContainer editorURL={editorURL}>{content}</ShareContainer>;
};
